/* Branches - This line cannot be edited or removed */
export const GET_BRANCHES = "GET_BRANCHES"
export const GET_BRANCHES_SUCCESS = "GET_BRANCHES_SUCCESS"
export const GET_BRANCHES_FAIL = "GET_BRANCHES_FAIL"

/* CREATE BRANCHES */
export const CREATE_BRANCH = "CREATE_BRANCH"
export const CREATE_BRANCH_SUCCESS = "CREATE_BRANCH_SUCCESS"
export const CREATE_BRANCH_FAIL = "CREATE_BRANCH_FAIL"

/* Edit BRANCH */
export const UPDATE_BRANCH = "UPDATE_BRANCH"
export const UPDATE_BRANCH_SUCCESS = "UPDATE_BRANCH_SUCCESS"
export const UPDATE_BRANCH_FAIL = "UPDATE_BRANCH_FAIL"

/* Delete BRANCH */
export const DELETE_BRANCH = "DELETE_BRANCH"
export const DELETE_BRANCH_SUCCESS = "DELETE_BRANCH_SUCCESS"
export const DELETE_BRANCH_FAIL = "DELETE_BRANCH_FAIL"

export const SELECT_BRANCH = "SELECT_BRANCH"
